import React from "react";

export default function HygieneExampleTable({ data }) {
    const rows = data ?? [];

    // Convert "company_name" → "Company Name"
    const toTitleCase = (value) =>
        (value ?? "")
            .toString()
            .replace(/[_\-]+/g, " ")
            .trim()
            .split(/\s+/)
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join(" ");

    // Zebra stripes matching report palette (same as Hygiene Checks, InsightTop10)
    const getRowColor = (index) => {
        return index % 2 === 0 ? "#f7fbff" : "#eef5fb";
    };

    // Semantic colors matching report (valid/suspect/invalid)
    const getResultColor = (checkResult) => {
        if (checkResult === "valid") return "#6da06f";
        if (checkResult === "invalid") return "#c13727";
        if (checkResult === "suspect") return "#fdba43";
        return "#333";
    };

    return (
        <div className="hc-box">
            <div className="hc-title">Example</div>
            <div className="hc-body">
                <table className="hc-table">
                    <tbody>
                    {rows.map((r, i) => (
                            <tr className="hc-row" key={i}>
                                <td
                                    className="hc-desc"
                                    title={toTitleCase(r.attribute)}
                                    style={{ backgroundColor: getRowColor(i), color: "#333" }}
                                >
                                    {toTitleCase(r.attribute)}
                                </td>
                                <td style={{ color: getResultColor(r.checkResult), fontWeight: 600, backgroundColor: "#ffffff" }}>
                                    {(r.value ?? "<no value>").toLocaleString()}
                                </td>
                            </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <style>{`
        .hc-box {
          border: 1px solid #d3d3d3;
          border-radius: 3px;
          background: #ffffff;
          font-family: sans-serif;
          font-size: 12px;
          overflow: hidden;
        }
        .hc-title {
          font-size: 16px;
          font-weight: 700;
          padding: 6px 10px;
          border-bottom: 1px solid #d3d3d3;
          background: #f5f5f5;
        }
        .hc-body {
          max-height: 600px;
          overflow-y: hidden;
          padding: 2px 3px;
        }
        .hc-table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          padding: 2px 4px;
        }
        .hc-desc {
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .hc-cnt {
          text-align: right;
          font-weight: 600;
          width: 120px;
        }
      `}</style>
        </div>
    );
}
